import _extends from "@babel/runtime/helpers/extends";
import { CustomBlock, PreviewBlock, TitleBlock } from '../../../../FlexibleCard/components/blocks';
import React from 'react';
import FlexibleCard from '../../../../FlexibleCard';
import { InternalFooterBlock } from '../../../../FlexibleCard/components/blocks';
import { FlexibleCardUiOptions, PreviewBlockOptions, titleBlockOptions, FooterBlockOptions } from '../utils';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
const customBlockStyles = css({
  alignItems: 'flex-start'
});
const UnresolvedView = ({
  actions,
  cardState,
  children,
  onAuthorize,
  onClick,
  onError,
  showPreview = false,
  testId,
  title,
  url
}) => /*#__PURE__*/React.createElement(FlexibleCard, {
  appearance: "block",
  cardState: cardState,
  onAuthorize: onAuthorize,
  onClick: onClick,
  onError: onError,
  testId: testId,
  ui: FlexibleCardUiOptions,
  url: url
}, /*#__PURE__*/React.createElement(TitleBlock, _extends({}, titleBlockOptions, {
  hideIcon: !!title,
  text: title
})), /*#__PURE__*/React.createElement(CustomBlock, {
  overrideCss: customBlockStyles
}, children), showPreview && /*#__PURE__*/React.createElement(PreviewBlock, PreviewBlockOptions), /*#__PURE__*/React.createElement(InternalFooterBlock, _extends({}, FooterBlockOptions, {
  actions: actions,
  testId: "smart-block-card-footer"
})));
export default UnresolvedView;